import React from 'react'
import { FormattedMessage } from 'react-intl'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import { ButtonWithLoading } from '../FormsyHelperComponent'

const createColor = (theme) => ({
  color: theme.palette.button.cancel.text,
  '&.MuiButton-root:hover': {
    backgroundColor: theme.palette.button.cancel.onHover.bg,
  },
  '&.MuiButton-text.MuiButton-root:active': {
    backgroundColor: theme.palette.button.cancel.onPress.bg,
  },
})

export const useStyles = makeStyles((theme) => ({
  labelCancel: {
    backgroundColor: theme.palette.button.cancel.bg,
    ...createColor(theme),
  },
  loading: createColor(theme),
}))

const SecondaryButton = ({ labelId, children, className, ...props }) => {
  const classes = useStyles()
  return (
    <ButtonWithLoading
      variant="text"
      className={clsx(classes.labelCancel, className, 'px-16')}
      CircularProp={{
        className: classes.loading,
      }}
      {...props}
    >
      {labelId ? <FormattedMessage id={labelId} /> : children}
    </ButtonWithLoading>
  )
}

export default SecondaryButton
